import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { ApiError, apiClient } from '@/lib/api-client';

/**
 * DELETE /api/proxy/admin/users/:id/sessions — bulk-revoke EVERY proxy
 * session belonging to a single user. First-response tool for TOS abuse
 * (spam / scraping). Drops both `cache:proxy:token:*` and
 * `cache:vless-session:*` entries; proxy-ingress / v2ray_edge return
 * 407/401 on the user's next request.
 *
 * Returns the number of entries actually removed — useful in the toast
 * so the operator can tell at a glance whether the user had any active
 * sessions in the first place.
 */
export function useRevokeUserSessions(): UseMutationResult<
  { revoked: number },
  ApiError,
  number
> {
  return useMutation({
    mutationFn: (userId: number) =>
      apiClient.delete<{ revoked: number }>(
        `/proxy/admin/users/${userId}/sessions`,
      ),
  });
}
